// extracted by mini-css-extract-plugin
export var anchor = "Card__anchor-Vj91h";
export var figure = "Card__figure-PnRyM";
export var footer = "Card__footer-ToPZV";
export var gatsbyAnchor = "Card__gatsbyAnchor-RaEij";
export var tag = "Card__tag-9ugQ5";
export var text = "Card__text-2R20r";
export var toolbar = "Card__toolbar-BZt-B";
export var wrapper = "Card__wrapper-Wpo8L";